module.exports = __webpack_public_path__ + "static/media/oven.21e2f745.svg";